import type { SeoMetaTagData } from '../cms';

// Dato strips the title suffix if it determines the combined title to be too long.
// We don't care we still want the suffix.
export const ensureTitleSuffix = (tags: SeoMetaTagData[], suffix?: string | null) => {
	if (!suffix) return tags;

	const titleIndex = tags.findIndex((tag) => tag.tag === 'title' && tag.content);
	if (titleIndex < 0) return tags;

	const tag = tags[titleIndex];
	if (!tag.content) return tags;

	const title = tag.content;
	if (title.endsWith(suffix)) return tags;

	const newTags = [...tags];

	newTags[titleIndex] = { ...tag, content: `${title} ${suffix}` };

	return newTags;
};
